/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { accessAPI, TablaFiltrable } from "../../shared";
import { abrirActividad, CAMPOS_BUSQUEDA, diasEnPasoBody, filasDePasos, filtrosDePasos } from "./pasosActividades";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Skeleton } from "primereact/skeleton";

// Actividades cuyo paso actual no tiene a nadie que lo decida: ni un
// colaborador decisor ni un administrador asignado.
export default function ActividadesSinDecisor({ toast }) {
  const navigate = useNavigate();
  const [pasos, setPasos] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/actividadessindecisor",
      null,
      (respuesta) => {
        setPasos(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar actividades sin decisor",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  if (!pasos || pasos.length === 0) {
    return null;
  }

  // Igual que en actividades abiertas: los procesos de juguetes van en su
  // propia sección colapsada.
  const juguetes = pasos.filter((p) => p.actividad.proceso.esjuguetes);
  const resto = pasos.filter((p) => !p.actividad.proceso.esjuguetes);

  const accordionCss = {
    marginTop: "1em",
    "& .p-accordion-header-link": { color: "black" },
    "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
  };

  return (
    <>
      {resto.length > 0 && (
        <Accordion activeIndex={null} css={accordionCss}>
          <AccordionTab header={`Actividades sin decisor (${resto.length})`}>
            <TablaFiltrable
              value={filasDePasos(resto)}
              searchFields={CAMPOS_BUSQUEDA}
              filtros={filtrosDePasos(false)}
              emptyMessage="No hay actividades sin decisor"
              nombreArchivo="actividades_sin_decisor"
              sortMode="multiple"
              removableSort
              onRowClick={abrirActividad(navigate)}
              css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
            >
              <Column header="Cliente" field="_cliente" sortable />
              <Column header="Proceso" field="_proceso" sortable />
              <Column header="Actividad" field="_actividad" sortable />
              <Column header="Paso actual" field="_paso" sortable />
              <Column
                header="Días en el paso actual"
                field="_diasEnPaso"
                sortable
                body={diasEnPasoBody}
                exportValue={(fila) => fila._diasEnPaso ?? "-"}
                style={{ width: "10em" }}
              />
            </TablaFiltrable>
          </AccordionTab>
        </Accordion>
      )}
      {juguetes.length > 0 && (
        <Accordion activeIndex={null} css={accordionCss}>
          <AccordionTab
            header={`Actividades sin decisor - juguetes (${juguetes.length})`}
          >
            <TablaFiltrable
              value={filasDePasos(juguetes)}
              searchFields={CAMPOS_BUSQUEDA}
              filtros={filtrosDePasos(false)}
              emptyMessage="No hay actividades de juguetes sin decisor"
              nombreArchivo="actividades_juguetes_sin_decisor"
              sortMode="multiple"
              removableSort
              onRowClick={abrirActividad(navigate)}
              css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
            >
              <Column header="Cliente" field="_cliente" sortable />
              <Column header="Proceso" field="_proceso" sortable />
              <Column header="Actividad" field="_actividad" sortable />
              <Column header="Paso actual" field="_paso" sortable />
              <Column
                header="Días en el paso actual"
                field="_diasEnPaso"
                sortable
                body={diasEnPasoBody}
                exportValue={(fila) => fila._diasEnPaso ?? "-"}
                style={{ width: "10em" }}
              />
            </TablaFiltrable>
          </AccordionTab>
        </Accordion>
      )}
    </>
  );
}
